import { Component, Input, OnInit } from "@angular/core";
import { EdtellProfileCardContainerConfig } from "../../interface/edtell-profile-card-container.interface";

@Component({
  selector: "edtell-profile-card-container",
  templateUrl: "./edtell-profile-card-container.component.html",
  styleUrls: ["./edtell-profile-card-container.component.scss"],
})
export class EdtellProfileCardContainerComponent implements OnInit {
  @Input()
  config?: EdtellProfileCardContainerConfig;

  hasHeader = false;
  headerSize = 0;

  constructor() {}

  ngOnInit() {
    if (this.config && this.config.headerText) {
      this.hasHeader = true;
      //   this.headerSize = this.config.headerSize ? this.config.headerSize : 2;
    }
  }
}
